import { oversizedUploadText } from './global-ui.constants';
export var locationsPage = {
    highchartSlugs: [
        'Indonesia-Legal-Classifications',
        'Land-Cover-Southeast-Asia',
        'Brazil-Biomes',
        'Indonesia-Land-Cover',
    ],
    lists: {
        confirmListUpdate: 'Confirm List Update',
        confirmListSubmission: 'Confirm Submission',
        addColumns: 'Add Columns',
        all: 'All',
        clearFilters: 'Clear filters',
        filter: 'Filter',
        filters: 'Filters',
        viewToggleLabel: 'View',
        viewForestChange: 'Forest Change',
        viewCommodityRisk: 'Commodity Risk',
        analyzing: 'Analyzing',
        failed: 'Failed',
        title: 'Lists',
        searchLists: 'Search Lists',
        searchStringInputPlaceholder: 'Type and press Enter',
        selectFilters: 'Select Filters',
        savedLocationsSummary: 'Summary',
        savedLocations: 'Saved Locations',
        allLocations: 'All Locations',
        investment: 'Investment',
        commodity: 'Commodity',
        commodityType: 'Commodity Type',
        locations: 'Locations',
        titleLocation: ' location',
        titleLocations: ' locations',
        titlePopoverCountries: 'Countries included',
        closePopover: 'Close',
        folderItem: 'list',
        folderItems: 'lists',
        myLists: 'My Lists',
        gfwLists: 'Global Forest Watch Lists',
        sharedLists: 'Shared Lists',
        listsFilterPlaceholder: 'Search lists...',
        listsFilterClear: 'Clear search',
        listsFilterNoMatch: 'Sorry, your search returned no results.',
        update: 'Update Analysis',
        submit: 'Submit Analysis',
        selectPlaceholder: 'Select...',
        selectCountry: 'Country',
        selectState: 'State',
        selectSubState: 'Sub state',
        parentCompanyLabel: 'Parent company',
        designationTypeLabel: 'Designation type',
        designationLabel: 'Designation',
        supplierLabel: 'Supplier',
        secondSupplierLabel: 'Second supplier',
        unselectAll: 'Unselect all',
        selectAll: 'Select all',
        filterModalTitle: 'Filters',
        protectedFiltersModalHeader: 'Show Protected Areas for',
        applyFilters: 'Apply filters',
        resetFilters: 'Reset',
        rerunListDialog: {
            title: 'Confirm Analysis Update',
            text: "<p>Click OK to submit this list for analysis. You will not be able to access the list until analysis is complete.\n      You will receive an email notification when the update is completed.</p>\n      <p>Note that running analysis counts towards your account usage limits. See more information <a target=\"_blank\" href=\"/about?section=Fees\">here</a>.</p>",
        },
        cancel: 'Cancel',
        confirm: 'Confirm',
        copy: 'Copy',
        ok: 'OK',
        delete: 'Delete',
        move: 'Move',
        moveExistingDescription: 'Note: Lists must have the same commodity defined in order to copy or move locations between lists. Your additional attribute data will be merged when attribute names match. Additional attribute data that does not match will be assigned separate columns.',
        moveLocationsDialogHeader: 'Move selection',
        copyLocationsDialogHeader: 'Copy selection',
        moveToNewListLabel: 'List name',
        moveToNewListDuplicate: 'A list with this name already exists',
        moveToNewListNameInvalid: 'The list name chosen contains punctuation. Please choose a list name with only letters, numbers, and/or spaces.',
        existing: 'Existing list',
        new: 'Create new',
        diagnostic: 'Diagnostic',
        map: 'Map',
        download: 'Download…',
        csv: 'CSV',
        shapefile: 'Shapefile',
        geojson: 'GeoJSON',
        share: 'Share',
        addToFolder: 'Add to folder',
        manage: 'Manage',
        changeTypeOfAnalysis: 'Change Type of analysis',
        deleteFolderTitle: 'Delete folder',
        deleteFolderPrompt: 'Are you sure you want to delete ',
        deleteFolderSuccessFragment: ' was deleted.',
        deleteFolderError: 'There was an error deleting the folder.',
        renameFolderTitle: 'Rename folder',
        renameFolderPrompt: 'Enter a new name to rename this folder.',
        renameFolderSuccessFragment: ' was renamed to ',
        renameFolderError: 'There was an error renaming the folder.',
        notFound: 'List not found',
        adminFilters: {
            modalHeader: 'Show Administrative Areas for',
            apply: 'Apply filters',
            selectCountry: 'Select...',
            selectStates: 'Select...',
            selectSubstates: 'Select...',
            selectCountryLabel: 'Country',
            selectStatesLabel: 'State',
            selectSubstatesLabel: 'Substate',
        },
        copyMoveMessages: {
            // server response keys
            ListTooLarge: { title: 'List exceeds maximum allowable size', message: oversizedUploadText },
            LocationAdded: {
                analytics: {
                    title: 'create new list click',
                    message: 'user copied locations from an existing list to create a new list',
                },
                title: 'Done',
                message: 'You have successfully uploaded your locations to a list.',
            },
            LocationsCopied: {
                analytics: {
                    title: 'create new list click',
                    message: 'user moved locations from an existing list to create a new list',
                },
                responseText: 'LocationsCopied',
                title: 'Locations Copied',
                message: 'You have successfully copied location(s) to an existing list.',
            },
            LocationMoved: {
                analytics: {
                    title: 'create new list click',
                    message: 'user copied locations from an existing list to a different pre-existing list',
                },
                title: 'Locations Moved',
                message: 'You have successfully moved your location(s) to an existing list.',
            },
            LocationAppended: {
                title: 'Done',
                message: 'You have successfully added these locations to a list.',
            },
            // moveLocations.js keys
            serverError: {
                title: 'Error in Locations',
                message: 'This account request has failed. Please try again at another time.',
            },
            listIsLocked: {
                title: 'List is locked',
                message: 'The list that you have selected is currently being edited by another user. Please try again later.',
            },
            invalidListName: {
                title: 'Invalid List Name',
                message: 'The list name chosen contains punctuation. Please choose a list name with only letters, numbers, and/or spaces.',
            },
            listNameAlreadyExists: {
                title: 'List not created',
                message: 'A list already exists with this name. Enter a new list name and click save.',
            },
            // listNotAccessible has no user-facing message
            listNotAccessible: { title: '', message: '' },
            missingListName: {
                title: 'Invalid List Name',
                message: 'You must create a new list or select an existing one.',
            },
        },
        deleteListDialog: {
            title: 'Confirm deletion',
            confirm: 'OK',
            cancel: 'Cancel',
            text: ' will be deleted. Please press ‘OK’ to confirm.',
        },
        deleteLocationsMessages: {
            confirm: {
                title: 'Confirm deletion',
                message: 'Are you sure you want to delete the selected location(s)? After saving, your list will be in draft state until you re-run analysis to account for your changes. Note that running analysis counts towards your account usage limits. See more information about usage & fees <a href="/about?section=Fees" target="_blank">here</a>.',
            },
            error: {
                title: 'Location(s) not deleted',
                message: 'This account request has failed. Please try again at another time.',
            },
            listLocked: {
                title: 'List is locked',
                message: 'The list that you have selected is currently being edited by another user. Please try again later',
            },
            success: {
                title: 'Location(s) Deleted',
                message: 'You have successfully deleted location(s) from [list-name]. Your list will now be in draft state until you re-run analysis to account for your changes. Note that running analysis counts towards your account usage limits. See more information about usage & fees <a href="/about?section=Fees" target="_blank">here</a>.',
            },
        },
        moveLocationsMessages: {
            error: {
                title: 'Location(s) not moved',
                message: 'This account request has failed. Please try again at another time.',
            },
            listLocked: {
                title: 'List is locked',
                message: 'The list that you have selected is currently being edited by another user. Please try again later',
            },
            success: { title: 'Location(s) Moved', message: 'Successfully moved the location(s).' },
        },
        manageFolderDialog: {
            addTitle: 'Add to folder',
            manageTitle: 'Move list to folder',
            confirm: 'Confirm',
            cancel: 'Cancel',
            // Translators: the name of the list is between these two strings
            add1: 'Add',
            add2: 'list to a new or existing folder',
            // Translators: the name of the list is between these two strings
            move1: 'Remove',
            move2: 'from this folder, or move it to a different folder',
            addToExisting: 'Add to existing',
            foldersSelectPlaceholder: 'Select...',
            createNew: 'Create new',
            removeFromFolder: 'Remove from folder',
            errorFolder: 'Error creating a new folder',
            errorList: 'Error adding list to folder',
            errorRemove: 'Error removing list from folder',
            // Translators: the name of the list is before string 1, and the name of
            // the folder is between these two strings
            added1: ' has been added to the ',
            added2: ' folder',
            // Translators: the name of the list is before string 1, and the name of
            // the folder is between these two strings
            moved1: ' has been moved to the ',
            moved2: ' folder',
            // Translators: the name of the list is before string 1, and the name of
            // the folder is between these two strings
            removed1: ' has been removed from the ',
            removed2: ' folder',
        },
        selectedCountry: 'Country',
        selectedCommodity: 'Commodity',
        selectedState: 'State',
        selectedSubState: 'Sub State',
        selectedCompany: 'Company',
        selectedArea: 'Area',
        selectedDesignationType: 'Designation Type',
        selectedDesignation: 'Designation',
        selectedNames: 'Names',
        selectedSupplier: 'Supplier',
        selectedSecondSupplier: 'Second Supplier',
        selectedParentCompany: 'Parent Company',
        selectedOverallThreats: 'Overall Threats',
        selectedOverallValues: 'Overall Values',
        selectedMillPriority: 'Mill Priority',
        selectedStates: 'States',
        selectedSubStates: 'Sub States',
        submitListDialog: {
            title: 'Confirm Analysis Submission',
            message: '<p>Click OK to submit this list for analysis. You will not be able to access the list until analysis is complete. You will receive an email notification when the update is completed.</p><p>Note that running analysis counts towards your account usage limits. See more information <a target="_blank" href="/about?section=Fees">here</a>.</p>',
        },
    },
    diagnosticsTitles: {
        TREE_COVER_LOSS: 'TREE COVER LOSS',
        TREE_COVER_LOSS_ON_ARGENTINA_OTBN: 'TREE COVER LOSS ON ARGENTINA OTBN',
        SOY_ON_TREE_COVER_LOSS: 'SOY ON TREE COVER LOSS',
        PRODES_AMAZON: 'PRODES (Amazon, Cerrado, Brazil)',
        ARGENTINA_OTBN_OVERLAP: 'ARGENTINA OTBN OVERLAP',
    },
    largeListEditing: {
        downloadProcessTitle: 'Upload process',
    },
    messageText: {
        investment: { text: 'Investment' },
        generic: { text: 'Generic' },
        other: { text: 'Other' },
        palmMill: { text: 'Palm Oil Mill' },
        palmPlantation: { text: 'Palm Oil Plantation' },
        palmFarm: { text: 'Palm Smallholder Farm' },
        palmGeneric: { text: 'Palm Oil Generic' },
        pulp: { text: 'Pulp and paper' },
        rubber: { text: 'Rubber' },
        soySilo: { text: 'Soy Silo' },
        soyFarm: { text: 'Soy Farm' },
        soyGeneric: { text: 'Soy Generic' },
        sugarCane: { text: 'Sugar Cane' },
        beef: { text: 'Beef Slaughterhouse' },
        cattle: { text: 'Cattle Ranch' },
        cattleGeneric: { text: 'Cattle Generic' },
        cocoa: { text: 'Cocoa Farm' },
        cocoaGeneric: { text: 'Cocoa Generic' },
        coffee: { text: 'Coffee' },
    },
    locationClassValues: {
        palmMill: { value: 'Supply Shed' },
        palmPlantation: { value: 'Property' },
        palmFarm: { value: 'Property' },
        cattle: { value: 'Property' },
        beef: { value: 'Supply Shed' },
        cocoa: { value: 'Property' },
        soyFarm: { value: 'Property' },
        soySilo: { value: 'Supply Shed' },
    },
    diagnostics: {
        lastDataYear: 2023,
    },
    landing: {
        foldersFeatureFlag: false,
        title: 'Locations',
        investment: 'Investment',
        investments: 'Investments',
        commodity: 'Commodity',
        commodities: 'Commodities',
        failedMessage: 'Analysis for this list failed. Please click update to try again.',
        pendingMessage: 'List is analyzing. You will receive an email once analysis is complete and can reload the page to access the results.',
        draftMessage: 'This list contains unanalyzed locations. Please click the submit button to run analysis. Once submitted, your list will not be accessible until analysis is complete.',
        addLocationsPrompt: '<p>Upload or enter locations by clicking the <strong>ADD LOCATIONS</strong> button. If you need help, read our <a target="_blank" class="no-lists__how-to" href="https://d1ps9kreypzu9a.cloudfront.net/Training%20Guides/GFW%20Pro%20Tutorials/GFW_Pro_UserGuide.pdf">how-to guide</a>.</p>',
        clearSearch: 'Clear search',
        noSearchResults: 'Sorry, your search returned no results.',
        total: 'Total',
        selectMethodOptions: [
            {
                commodityOrder: 3,
                investmentOrder: 1,
                label: 'By Address',
                landingLabel: 'Enter Address',
                id: 'byAddress',
                type: 'both',
            },
            // {commodityOrder: 5, investmentOrder: 5, label: 'By Selecting Administrative Region', landingLabel: 'Select Administrative Area', id: 'bySelection', type: 'both'},
            // {commodityOrder: 9, investmentOrder: 7, label: 'By Selecting Protected Area', landingLabel: 'Select Protected Area', id: 'byProtected', type: 'both'},
            // {commodityOrder: 7, investmentOrder: 6, label: 'By Selecting Concession Area', landingLabel: 'Select Concession Area', id: 'byConcession', type: 'both'},
            // {commodityOrder: 6, investmentOrder: 10, label: 'By Selecting Certified Area', landingLabel: 'Select Certified Area', id: 'byCertified', type: 'commodity'},
            // {commodityOrder: 8, investmentOrder: 10, label: 'By Selecting Palm Oil Mill', landingLabel: 'Select Palm Oil Mill', id: 'byPalmMill', type: 'commodity'},
            {
                commodityOrder: 2,
                investmentOrder: 3,
                label: 'By Drawing Shape',
                landingLabel: 'Draw a Shape',
                id: 'byDrawing',
                type: 'both',
            },
            {
                commodityOrder: 1,
                investmentOrder: 4,
                label: 'By Uploading Shape File',
                landingLabel: 'Upload a File',
                id: 'byUpload',
                type: 'both',
            },
        ],
        addLocation: 'Add a Location',
        addLocations: 'Add locations',
        addLocationChooser: {
            title: 'Choose single or multiple location upload',
            single: {
                id: 'AddSingleLocation',
                header: 'Add a single location',
                text: 'You will be able to enter an address or coordinates; draw a shape; or upload a shape file.',
            },
            multiple: {
                id: 'UploadMultipleLocations',
                header: 'Upload multiple locations',
                text: 'Start here to upload a file of less than 5MB and up to 1,500 locations.',
            },
        },
        download: 'Download',
        downloadMenuOpt: 'Download…',
        uploadLocation: 'Upload Locations',
        myLocations: 'My Locations',
        myLists: 'My Lists',
        mySharedLists: 'My Shared Lists',
        listsSharedWithMe: 'Lists Shared With Me',
        myFolders: 'My Folders',
        resultItem: 'result',
        resultItems: 'results',
        gfwLists: 'Global Forest Watch Lists',
        sharedLists: 'Shared Lists',
        tempLists: [
            {
                name: 'Brazil Soy',
                locations: 40,
                externalShared: false,
                internalShared: false,
            },
            {
                name: 'Paraguay Beef',
                locations: 25,
                externalShared: true,
                internalShared: true,
            },
            {
                name: 'Q3 Palm Mills',
                locations: 100,
                externalShared: true,
                internalShared: false,
            },
        ],
        tempSharedLists: [
            {
                list_name: 'Financial Institution B',
                locations: 40,
            },
            {
                list_name: 'Supplier 1 Q3 Palm Mills',
                locations: 20,
            },
        ],
    },
    add: {
        title: 'Add Location',
        enterCoordinates: 'Enter Coordinates',
        longitude: 'Longitude',
        latitude: 'Latitude',
        selectAdmin: 'Select Administrative Region',
        draw: {
            button: {
                startDrawing: 'Start Drawing',
                cancel: 'Cancel',
                redraw: 'Re-draw',
            },
            help: 'Click to start drawing, then click the first point to close your custom area of interest.',
        },
        dropdownOptions: [
            { label: 'Investment', id: 'investment' },
            { label: 'Commodity', id: 'commodity' },
        ],
        define: 'Location',
        investmentName: 'Investment name',
        locationLabel: 'Location: ',
        commodityName: 'Location name',
        defineRadiusHeader: 'Define radius around location',
        smallArea: 'Small',
        smallAreaSizeHint: '1000 hectares (1.78 km radius)',
        mediumArea: 'Medium',
        mediumAreaSizeHint: '5000 hectares (3.99 km radius)',
        largeArea: 'Large',
        largeAreaSizeHint: '20,000 hectares (7.98 km radius)',
        customAreaLabel: 'Custom area',
        customRadiusLabel: 'Custom radius',
        customAreaPlaceholder: 'Enter area (in ha) or radius (in km)',
        customAreaInputLabel: 'Enter area (in ha) or radius (in km)',
        calculatedSourcingArea: 'Calculated sourcing area (ha)',
        hectareAbbrev: 'ha',
        kilometerAbbrev: 'km',
        help: 'Help',
        suggestedRadii: 'Suggested radius',
        fiftyKmPalm: '50km for palm oil mills',
        thirtyKmSoy: '30km for soy silos',
        dash18KmCocoa: '0.5-18km for cocoa warehouses',
        suggestedAreas: 'Suggested areas',
        haPalm: '785,000 hectares for palm oil mills',
        haSoy: '283,000 hectares for soy silos',
        haCocoa: '80-102,000 hectares for cocoa warehouses',
        cancel: 'Cancel',
        continue: 'Continue',
        errors: {
            fileExtensionNotSupported: {
                title: 'File extension not supported',
                message: 'The supported file extensions are: csv, xlx, zip, kml, and kmz.',
            },
        },
        next: 'Next',
        prev: 'Previous',
        validLocation: ' valid location',
        validLocations: ' valid locations',
        invalidLocation: ' invalid location',
        invalidLocations: ' invalid locations',
        saveAndAddAnother: 'Save and add another',
        submit: 'Submit Analysis',
        upload: 'Upload File:',
        uploadError: 'Upload error',
        sizeOfInvestment: 'Size of Investment',
        timeframe: 'Review timeframe',
        timeframeDesc: 'Select start and end dates or time horizon for this location’s review period.',
        additionalMetadata: 'Additional metadata',
        startDate: 'Start Date',
        endDate: 'End Date',
        protectedAreas: {
            localhost: 'Lz6YLHN1eyIwJNZDNp1IkFglwrO6qQfAwwRGz-KkyrPDyOjRgiP02tf7gQnD0sRy',
            'pro-staging.globalforestwatch.org': 'P9JirtCtnVDKuuxWwOOzhkjXTZhYZOdOX2lx9ucHcY9bwMkxyvwIq9cm4o7BiH4Cajir0vspLArlORz21jEI7A..',
            'gfwpro.globalforestwatch.org': 'W6ezC-46IViJqpkOg4WvhoLeqgc5XwCY6US2vChHuAf0tSffb4gNXBEkzRwVT5t3gMLrs3TRPUfspw-5Z-dxTQ..',
            'pro.globalforestwatch.org': 'MCrBhmBWwyPefdQamP74oGxZkDeWMoeP5qSUlKkeYxMInNyuC7e2Sg_5Cz70d8UQU4Y5lEALv2dedpuGo5Dv3A..',
        },
        address: 'Address',
        optional: '(optional)',
        addToAnExistingList: 'Add to an existing list',
    },
    upload: {
        errors: {
            uploadErrorDialogDownloadMessageTitle: 'Download error file',
        },
        filetypes: {
            title: 'Accepted filetypes:',
            csv: 'CSV or Excel file',
            zip: 'ZIP file containing a shapefile (SHP, DBF, SHX, and PRJ)',
            kml: 'KML or KMZ',
        },
        submit: 'Submit Analysis',
        list: 'List',
        analysis: 'List Analyses',
        addToExisting: 'Add to existing',
        createNew: 'Create new',
        browse: 'Browse',
        selectPlaceholder: 'Select…',
        show: 'Show',
    },
    columns: {
        notAnalyzedList: {
            owner: 'This location has not been analyzed. To view location details and diagnostics for this list, please click the submit button at the top of the screen.',
            nonOwner: 'This location has not been analyzed. The list owner will need to submit the list for analysis. Once submitted, this list will not be accessible until analysis is complete.',
        },
        tooltipMessage: 'This location has failed analysis. To receive results, resubmit this list for analysis.',
    },
    usageReachingLimitBanner: {
        title: 'You have reached over 90% of your free usage limits.',
        text: 'After hitting your account limit, new and updated analyses will be unavailable until your account administrator purchases additional usage, or until your free usage limits renew on your annual account renewal date. Administrators may review the Usage dashboard for more information and to place an order.',
    },
    usegeReachedLimitBanner: {
        title: 'This account has consumed available use quantities.',
        text: 'New and updated analyses will be unavailable until your account administrator purchases additional usage, or until your free usage limits renew on your annual account renewal date. Administrators may review the Usage dashboard for more information and to place an order.',
    },
};
